export default function(name, data){
    if (!this.messageHandlers[name]) {
        return false;
    }

    this.messageHandlers[name].forEach(function (handler) {
        try{
            handler(data);
        }catch(e){
            this.log('error', e);
        } 
    });
}

